import React, { FC } from 'react';
import { RocheUIAnimatedWords } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

type RocheAnimatedWordsProps = BlokToComponentProps<{
  headline: string;
  words: string;
}>;

export const RocheAnimatedWords: FC<RocheAnimatedWordsProps> = ({ blok }) => <RocheUIAnimatedWords {...blok} />;
